import React from 'react';
import { PhoneState } from '../types';

const usePhoneNumberState = (): {
  phoneState: PhoneState;
  setPhoneState(PhoneState): void;
} => {
  const [phoneState, setPhoneState] = React.useState<PhoneState>({
    fullNumber: '',
    code: '',
    phoneNumber: '',
    error: '',
    isValid: false,
  });

  return { phoneState, setPhoneState };
};

export default usePhoneNumberState;
